<template>
    <div>
        <Splash v-if="view == 'splash'"></Splash>
        <Menu v-if="view == 'menu'" @launch="launch"></Menu>
        <Game v-if="view == 'game'" @quit="quit" :params="params"></Game>
    </div>
</template>

<script>
const initialView = new URL(window.location.href).searchParams.get("view");

export default {
    data() {
        return { view: initialView || "splash", params: {} };
    },
    methods: {
        launch(params) {
            this.params = params;
            this.view = "game";
        },
        quit() {
            this.view = "menu";
        }
    },
    mounted() {
        document.addEventListener("keydown", e => {
            if (e.key == "Q") {
                this.view = "menu";
            }
        });

        window.setTimeout(() => (this.view = this.view == "splash" ? "menu" : this.view), 2500);
    }
};
</script>
